import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function CrossIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M15 5L5 15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M5 5L15 15"
  }));
}

export { CrossIcon };
//# sourceMappingURL=Cross.mjs.map
